export type TenantBranding = {
  site_name: string;
  logo_url: string | null;
  favicon_url?: string | null;
};

export const DEFAULT_SITE_NAME = "Campingplatz";
